export default __webpack_public_path__ + "static/media/grafema_amcc_10.85e0e305.jpg";